import React, { useState, useRef, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const SORT_OPTIONS = [
  { value: '',          label: 'Default'           },
  { value: 'priceAsc',  label: 'Price: Low → High' },
  { value: 'priceDesc', label: 'Price: High → Low' },
  { value: 'popularity',label: 'Popularity'         },
];

const SortOptions = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const current = searchParams.get("sortBy") || "";
  const currentLabel = SORT_OPTIONS.find(o => o.value === current)?.label || 'Default';

  const handleSelect = (value) => {
    searchParams.set("sortBy", value);
    setSearchParams(searchParams);
    setOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Exo+2:wght@300;400;500&display=swap');

        .so-wrap {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          font-family: 'Exo 2', sans-serif;
          position: relative;
        }

        .so-label {
          font-size: 8px;
          font-weight: 400;
          letter-spacing: 0.45em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
          white-space: nowrap;
        }

        /* Trigger button */
        .so-trigger {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: #f8f8f8;
          color: #000;
          border: none;
          outline: none;
          font-family: 'Exo 2', sans-serif;
          font-size: 9px;
          font-weight: 500;
          letter-spacing: 0.3em;
          text-transform: uppercase;
          padding: 9px 14px;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s ease;
          user-select: none;
        }
        .so-trigger:hover { background: #e8e8e8; }

        .so-chevron {
          display: flex;
          align-items: center;
          transition: transform 0.2s ease;
          flex-shrink: 0;
        }
        .so-chevron.open { transform: rotate(180deg); }

        /* Dropdown panel */
        .so-dropdown {
          position: absolute;
          top: calc(100% + 2px);
          right: 0;
          background: #f8f8f8;
          min-width: 100%;
          z-index: 100;
          overflow: hidden;
          /* animate in */
          animation: so-fade-in 0.15s ease;
        }
        @keyframes so-fade-in {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .so-option {
          display: block;
          width: 100%;
          padding: 10px 14px;
          font-family: 'Exo 2', sans-serif;
          font-size: 9px;
          font-weight: 400;
          letter-spacing: 0.28em;
          text-transform: uppercase;
          color: rgba(0,0,0,0.5);
          background: transparent;
          border: none;
          outline: none;
          text-align: left;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.15s ease, color 0.15s ease;
          border-top: 1px solid rgba(0,0,0,0.06);
        }
        .so-option:first-child { border-top: none; }
        .so-option:hover {
          background: #000;
          color: #fff;
        }
        .so-option.active {
          color: #000;
          font-weight: 600;
        }
      `}</style>

      <div className="so-wrap" ref={wrapRef}>
        <span className="so-label">Sort</span>

        {/* Trigger */}
        <button className="so-trigger" onClick={() => setOpen(prev => !prev)}>
          {currentLabel}
          <span className={`so-chevron ${open ? 'open' : ''}`}>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </button>

        {/* Dropdown */}
        {open && (
          <div className="so-dropdown">
            {SORT_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                className={`so-option ${current === opt.value ? 'active' : ''}`}
                onClick={() => handleSelect(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SortOptions;
